import { render } from "./UldkasulikTooLeht.vue?vue&type=template&id=7476fe35&ts=true"
import script from "./UldkasulikTooLeht.vue?vue&type=script&lang=ts"
export * from "./UldkasulikTooLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__